import axios from 'axios'
import { BUSCAR_RESERVAS_REMARCACAO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarPedidoRemarcacao (parametros) {
  return dispatch => axios.post(`${URL}/reserva/reservas-remarcacao`, parametros, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: BUSCAR_RESERVAS_REMARCACAO,
      payload: {
        reservas: response.data,
      }
    })
  )
}
